<template>
  <div class="packages">
    <div class="packages-title-n">
      <h3>مستقبلك يبدأ من هنا</h3>
      <h2>تعليم تفاعلي، استثمار ذكي</h2>
    </div>

    <!-- Package Duration Selection (Only for Kids) -->
    <div class="packages-menu-n" v-if="selectedFilter === 'kids'">
      <ul>
        <li @click="selectMenu('two-months')" :class="{ selected: selectedMenu === 'two-months' }">شهرين</li>
        <li @click="selectMenu('four-months')" :class="{ selected: selectedMenu === 'four-months' }">4 أشهر</li>
        <li @click="selectMenu('six-months')" :class="{ selected: selectedMenu === 'six-months' }">6 أشهر</li>
        <li @click="selectMenu('eight-months')" :class="{ selected: selectedMenu === 'eight-months' }">8 أشهر</li>
      </ul>
    </div>

    <!-- Kids Packages -->
    <div v-if="selectedFilter === 'kids'">
      <div class="packages-cards" v-if="selectedMenu === 'two-months'">
        <!-- Two Months Cards -->
        <div class="package-card">
          <div class="card-header">
            <h3>
              <span> (شهرين) </span>
              <br />
              المعايشة بلس
            </h3>
          </div>

          <div class="card-body">
            <p>
              "المعايشة بلس" هي باقتك المثالية، تقدم أقصى قيمة مقابل السعر
              بميزات فريدة وخدمة شاملة تضمن راحتك.
            </p>

            <div class="flex flex-row justify-between items-start bg-[#EAEAEA66] shadow-[0px_4px_10px_0px_#0000001A_inset] p-2 rounded-[20px] mb-2">
              <div class="bg-white rounded-[20px] border-x border-y border-[#F47D21] min-h-[56px] px-5 py-2 grid place-content-center text-start">
                <div class="text-[#F47D21] text-[13px] leading-4">سعر المستوى</div>
                <div class="flex items-baseline justify-center gap-1 leading-none">
                  <span class="text-[#F47D21] text-sm">الواحد</span>
                  <span class="text-[#F47D21] font-extrabold text-[26px]" v-text="prices[3]?.perLevelAmount"></span>
                </div>
              </div>
              <div class="price">
                <p class="bg-gradient-to-l from-[#F47D21] to-[#FF9D52] bg-clip-text !text-transparent !font-bold !text-5xl !mt-0 !mb-0">{{ prices[3]?.originalPrice }}</p>
              </div>
            </div>

            <h6>واستمتع بالاتي:</h6>
            <ul>
              <li>حصص أســـــــاسية:<span> 8 شهرياً</span></li>
              <li>نادى القـــــــــــــــــراءة:<span> مرة أسبوعياً</span></li>
              <li>نادى الســــــــــــــينما:<span>مرة أسبوعياً</span></li>
              <li>نادى المــــــــــــحادثة:<span> يومياً</span></li>
              <li>نادى المـــــــناظرات:<span> مرة شهرياً</span></li>
              <li>نادى الكتــــــــــــــــــــابة:<span> مرة أسبوعياً</span></li>
              <li>نادى الصوتــــــــــيات:<span> بترشيح المعلم</span></li>
              <li>نادى المـــــــــواهب:<span> مرة أسبوعياً</span></li>
              <li>نادى الرســـــــــــــــــــم:<span> مرة أسبوعياً</span></li>
              <li>لقاء تربوي مع ولي الأمر: <span> مرة شهرياً</span></li>
              <li>نادى لايف كوتش:<span> جلسة مجانية</span></li>
              <li>إجتماع شهري لأولياء الأمور</li>
              <li>تقاريــــــر شهريـــــــــــة مفصلة لمستوى اللغة</li>
            </ul>
            <button @click="addToCart(prices[3]?.packageId)">شراء</button>
            <!-- <p class="!text-lg max-sm:!text-md font-normal text-center">الأسعار لا تشمل ضريبة القيمة المضافة VAT</p> -->
          </div>
        </div>
        <div class="package-card">
          <div class="card-header">
            <h3><span> (شهرين)</span> <br />المعايشة</h3>
          </div>
          <div class="card-body">
            <p>
              باقة “المعايشة” توفر العديد من الميزات وهي الخيار المعتاد
              لعملائنا، تضمن الراحة والخدمات المتميزة بكفاءة.
            </p>
            <div class="flex flex-row justify-between items-start bg-[#EAEAEA66] shadow-[0px_4px_10px_0px_#0000001A_inset] p-2 rounded-[20px] mb-2">
              <div class="bg-white rounded-[20px] border-x border-y border-[#F47D21] min-h-[56px] px-5 py-2 grid place-content-center text-start">
                <div class="text-[#F47D21] text-[13px] leading-4">سعر المستوى</div>
                <div class="flex items-baseline justify-center gap-1 leading-none">
                  <span class="text-[#F47D21] text-sm">الواحد</span>
                  <span class="text-[#F47D21] font-extrabold text-[26px]" v-text="prices[2]?.perLevelAmount"></span>
                </div>
              </div>
              <div class="price">
                <p class="bg-gradient-to-l from-[#F47D21] to-[#FF9D52] bg-clip-text !text-transparent !font-bold !text-5xl !mt-0 !mb-0">{{ prices[2]?.originalPrice }}</p>
              </div>
            </div>

            <h6>واستمتع بالاتي:</h6>
            <ul>
              <li>حصص أســـــــاسية:<span> 8 شهرياً</span></li>
              <li>نادى القـــــــــــــــــراءة:<span> مرة أسبوعياً</span></li>
              <li>نادى الســــــــــــــينما:<span>مرة أسبوعياً</span></li>
              <li>نادى المــــــــــــحادثة:<span> يومياً</span></li>
              <li>نادى المـــــــناظرات:<span> مرة شهرياً</span></li>
              <li>نادى لايف كوتش:<span>جلسة مجانية</span></li>
              <li>تقاريــــــر شهريـــــــــــة مفصلة لمستوى اللغة</li>
            </ul>
            <button @click="addToCart(prices[2]?.packageId)">شراء</button>
            <!-- <p class="!text-lg max-sm:!text-md font-normal text-center">الأسعار لا تشمل ضريبة القيمة المضافة VAT</p> -->
          </div>
        </div>
        <div class="package-card">
          <div class="card-header">
            <h3>
              <span> (شهرين)</span>
              <br />
              أساسية
            </h3>
          </div>
          <div class="card-body">
            <p>
              باقة مونجلش الأساسية هي الأقل سعراً، ولكنها تحتوي على بعض ميزات
              دوراتنا التي توفر تجربة تعليمية مميزة.
            </p>
            <div class="flex items-start justify-between gap-3 bg-[#EAEAEA66] shadow-[0px_4px_10px_0px_#0000001A_inset] px-4 py-3 rounded-[20px] mb-2">
              <div class="bg-white rounded-[20px] border-x border-y border-[#F47D21] min-h-[56px] px-5 py-2 grid place-content-center text-start">
                <div class="text-[#F47D21] text-[13px] leading-4">سعر المستوى</div>
                <div class="flex items-baseline justify-center gap-1 leading-none">
                  <span class="text-[#F47D21] text-sm">الواحد</span>
                  <span class="text-[#F47D21] font-extrabold text-[26px]" v-text="prices[1]?.perLevelAmount"></span>
                </div>
              </div>
              <div class="price">
                <p class="bg-gradient-to-l from-[#F47D21] to-[#FF9D52] bg-clip-text !text-transparent !font-bold !text-5xl !mt-0 !mb-0">{{ prices[1]?.originalPrice }}</p>
              </div>
            </div>

            <h6>واستمتع بالاتي:</h6>
            <ul>
              <li>حصص أســـــــاسية:<span> 8 شهرياً</span></li>
              <li>نادى القـــــــــــــــــراءة:<span> مرة شهرياً</span></li>
              <li>نادى المـــــــناظرات:<span> مرة شهرياً</span></li>
              <li>تقاريــــــر شهريـــــــــــة مفصلة لمستوى اللغة</li>
            </ul>
            <button @click="addToCart(prices[1]?.packageId)">شراء</button>
            <!-- <p class="!text-lg max-sm:!text-md font-normal text-center">الأسعار لا تشمل ضريبة القيمة المضافة VAT</p> -->
          </div>
        </div>
      </div>
      <div class="packages-cards" v-else-if="selectedMenu === 'four-months'">
        <!-- Four Months Cards -->
        <div class="package-card">
          <div class="card-header">
            <h3>
              <span> (4 شهور)</span>
              <br />
              المعايشة بلس
            </h3>
          </div>
          <div class="card-body">
            <p>
              “المعايشة بلس” هي باقتك المثالية، تقدم أقصى قيمة مقابل السعر
              بميزات فريدة وخدمة شاملة تضمن راحتك.
            </p>

            <div class="flex flex-row justify-between items-start bg-[#EAEAEA66] shadow-[0px_4px_10px_0px_#0000001A_inset] p-2 rounded-[20px] mb-2">
              <div class="bg-white rounded-[20px] border-x border-y border-[#F47D21] min-h-[56px] px-5 py-2 grid place-content-center text-start">
                <div class="text-[#F47D21] text-[13px] leading-4">سعر المستوى</div>
                <div class="flex items-baseline justify-center gap-1 leading-none">
                  <span class="text-[#F47D21] text-sm">الواحد</span>
                  <span class="text-[#F47D21] font-extrabold text-[26px]" v-text="prices[6]?.perLevelAmount"></span>
                </div>
              </div>
              <div class="price flex items-center gap-x-2">
                <span class="sloped-line">{{ prices[6]?.beforePrice }}</span>
                <p class="bg-gradient-to-l from-[#F47D21] to-[#FF9D52] bg-clip-text !text-transparent !font-bold !text-5xl !mt-0 !mb-0">{{ prices[6]?.originalPrice }}</p>
              </div>
            </div>
            <h6>واستمتع بالاتي:</h6>
            <ul>
              <li>حصص أســـــــاسية:<span> 8 شهرياً</span></li>
              <li>نادى القـــــــــــــــــراءة:<span> مرة أسبوعياً</span></li>
              <li>نادى الســــــــــــــينما:<span>مرة أسبوعياً</span></li>
              <li>نادى المــــــــــــحادثة:<span> يومياً</span></li>
              <li>نادى المـــــــناظرات:<span> مرة شهرياً</span></li>
              <li>نادى المـــــــــواهب:<span>مرة أسبوعياً</span></li>
              <li>نادى الرســـــــــــــــــــم:<span>مرة أسبوعياً</span></li>
              <li>لقاء تربوي مع ولي الأمر:<span> مرة شهرياً</span></li>
              <li>نادى الصوتــــــــــيات:<span> بترشيح المعلم</span></li>
              <li>نادى الكتــــــــــــــــــــابة:<span>مرة أسبوعياً</span></li>
              <li>نادى لايف كوتش:<span>جلسة مجانية</span></li>
              <li>إجتماع شهري لأولياء الأمور</li>
              <li>تقاريــــــر شهريـــــــــــة مفصلة لمستوى اللغة</li>
            </ul>
            <button @click="addToCart(prices[6]?.packageId)">شراء</button>
            <!-- <p class="!text-lg max-sm:!text-md font-normal text-center">الأسعار لا تشمل ضريبة القيمة المضافة VAT</p> -->
          </div>
        </div>
        <div class="package-card">
          <div class="card-header">
            <h3>
              <span> (4 شهور)</span>
              <br />
              المعايشة
            </h3>
          </div>
          <div class="card-body">
            <p>
              باقة “المعايشة” توفر العديد من الميزات وهي الخيار المعتاد
              لعملائنا، تضمن الراحة والخدمات المتميزة بكفاءة.
            </p>
            <div class="flex flex-row justify-between items-start bg-[#EAEAEA66] shadow-[0px_4px_10px_0px_#0000001A_inset] p-2 rounded-[20px] mb-2">
              <div class="bg-white rounded-[20px] border-x border-y border-[#F47D21] min-h-[56px] px-5 py-2 grid place-content-center text-start">
                <div class="text-[#F47D21] text-[13px] leading-4">سعر المستوى</div>
                <div class="flex items-baseline justify-center gap-1 leading-none">
                  <span class="text-[#F47D21] text-sm">الواحد</span>
                  <span class="text-[#F47D21] font-extrabold text-[26px]" v-text="prices[5]?.perLevelAmount"></span>
                </div>
              </div>
              <div class="price flex items-center gap-x-2">
                <span class="sloped-line">{{ prices[5]?.beforePrice }}</span>
                <p class="bg-gradient-to-l from-[#F47D21] to-[#FF9D52] bg-clip-text !text-transparent !font-bold !text-5xl !mt-0 !mb-0">{{ prices[5]?.originalPrice }}</p>
              </div>
            </div>
            <h6>واستمتع بالاتي:</h6>
            <ul>
              <li>حصص أســـــــاسية:<span> 8 شهرياً</span></li>
              <li>نادى القـــــــــــــــــراءة:<span> مرة أسبوعياً</span></li>
              <li>نادى الســــــــــــــينما:<span>مرة أسبوعياً</span></li>
              <li>نادى المــــــــــــحادثة:<span> يومياً</span></li>
              <li>نادى المـــــــناظرات:<span> مرة شهرياً</span></li>
              <li>نادى لايف كوتش:<span>جلسة مجانية</span></li>
              <li>تقاريــــــر شهريـــــــــــة مفصلة لمستوى اللغة</li>
            </ul>
            <button @click="addToCart(prices[5]?.packageId)">شراء</button>
            <!-- <p class="!text-lg max-sm:!text-md font-normal text-center">الأسعار لا تشمل ضريبة القيمة المضافة VAT</p> -->
          </div>
        </div>
        <div class="package-card">
          <div class="card-header">
            <h3>
              <span> (4 شهور)</span>
              <br />
              أساسية
            </h3>
          </div>
          <div class="card-body">
            <p>
              باقة مونجلش الأساسية هي الأقل سعراً، ولكنها تحتوي على بعض ميزات
              دوراتنا التي توفر تجربة تعليمية مميزة.
            </p>
            <div class="flex flex-row justify-between items-start bg-[#EAEAEA66] shadow-[0px_4px_10px_0px_#0000001A_inset] p-2 rounded-[20px] mb-2">
              <div class="bg-white rounded-[20px] border-x border-y border-[#F47D21] min-h-[56px] px-5 py-2 grid place-content-center text-start">
                <div class="text-[#F47D21] text-[13px] leading-4">سعر المستوى</div>
                <div class="flex items-baseline justify-center gap-1 leading-none">
                  <span class="text-[#F47D21] text-sm">الواحد</span>
                  <span class="text-[#F47D21] font-extrabold text-[26px]" v-text="prices[4]?.perLevelAmount"></span>
                </div>
              </div>
              <div class="price">
                <p class="bg-gradient-to-l from-[#F47D21] to-[#FF9D52] bg-clip-text !text-transparent !font-bold !text-5xl !mt-0 !mb-0">{{ prices[4]?.originalPrice }}</p>
              </div>
            </div>

            <h6>واستمتع بالاتي:</h6>
            <ul>
              <li>حصص أســـــــاسية:<span> 8 شهرياً</span></li>
              <li>نادى القـــــــــــــــــراءة:<span> مرة شهرياً</span></li>
              <li>نادى المـــــــناظرات:<span> مرة شهرياً</span></li>
              <li>تقاريــــــر شهريـــــــــــة مفصلة لمستوى اللغة</li>
            </ul>
            <button @click="addToCart(prices[4]?.packageId)">شراء</button>
            <!-- <p class="!text-lg max-sm:!text-md font-normal text-center">الأسعار لا تشمل ضريبة القيمة المضافة VAT</p> -->
          </div>
        </div>
      </div>
      <div class="packages-cards" v-else-if="selectedMenu === 'six-months'">
        <!-- Six Months Cards -->
        <div class="package-card">
          <div class="card-header">
            <h3>
              <span> (6 اشهر)</span>
              <br />
              المعايشة بلس
            </h3>
            <p class="badge">
              <span>الأفضل <br />
                <bold>قيمة</bold>
              </span>
            </p>
          </div>
          <div class="card-body">
            <p>
              “المعايشة بلس” هي باقتك المثالية، تقدم أقصى قيمة مقابل السعر
              بميزات فريدة وخدمة شاملة تضمن راحتك.
            </p>
            <div class="flex flex-row justify-between items-start bg-[#EAEAEA66] shadow-[0px_4px_10px_0px_#0000001A_inset] p-2 rounded-[20px] mb-2">
              <div class="bg-white rounded-[20px] border-x border-y border-[#F47D21] min-h-[56px] px-5 py-2 grid place-content-center text-start">
                <div class="text-[#F47D21] text-[13px] leading-4">سعر المستوى</div>
                <div class="flex items-baseline justify-center gap-1 leading-none">
                  <span class="text-[#F47D21] text-sm">الواحد</span>
                  <span class="text-[#F47D21] font-extrabold text-[26px]" v-text="prices[8]?.perLevelAmount"></span>
                </div>
              </div>
              <div class="price flex items-center gap-x-2">
                <span class="sloped-line">{{ prices[8]?.beforePrice }}</span>
                <p class="bg-gradient-to-l from-[#F47D21] to-[#FF9D52] bg-clip-text !text-transparent !font-bold !text-5xl !mt-0 !mb-0">{{ prices[8]?.originalPrice }}</p>
              </div>
            </div>
            <h6>واستمتع بالاتي:</h6>
            <ul>
              <li>حصص أســـــــاسية:<span> 8 شهرياً</span></li>
              <li>نادى القـــــــــــــــــراءة:<span> مرة أسبوعياً</span></li>
              <li>نادى الســــــــــــــينما:<span>مرة أسبوعياً</span></li>
              <li>نادى المــــــــــــحادثة:<span> يومياً</span></li>
              <li>نادى المـــــــناظرات:<span> مرة شهرياً</span></li>
              <li>نادى الكتــــــــــــــــــــابة:<span>مرة أسبوعياً</span></li>
              <li>نادى الصوتــــــــــيات:<span> بترشيح المعلم</span></li>
              <li>نادى المـــــــــواهب:<span>مرة أسبوعياً</span></li>
              <li>نادى الرســـــــــــــــــــم:<span>مرة أسبوعياً</span></li>
              <li>لقاء تربوي مع ولي الأمر:<span> مرة شهرياً</span></li>
              <li>نادى لايف كوتش:<span>جلسة مجانية</span></li>
              <li>إجتماع شهري لأولياء الأمور</li>
              <li>تقاريــــــر شهريـــــــــــة مفصلة لمستوى اللغة</li>
            </ul>
            <button @click="addToCart(prices[8]?.packageId)">شراء</button>
            <!-- <p class="!text-lg max-sm:!text-md font-normal text-center">الأسعار لا تشمل ضريبة القيمة المضافة VAT</p> -->
          </div>
        </div>
        <div class="package-card">
          <div class="card-header">
            <h3>
              <span> (6 اشهر)</span>
              <br />
              المعايشة
            </h3>
            <p class="badge">
              <span
                >الأكثر <br />
                <bold>مبيعاً</bold>
              </span>
            </p>
          </div>
          <div class="card-body">
            <p>
              باقة “المعايشة” توفر العديد من الميزات وهي الخيار المعتاد
              لعملائنا، تضمن الراحة والخدمات المتميزة بكفاءة.
            </p>
            <div class="flex flex-row justify-between items-start bg-[#EAEAEA66] shadow-[0px_4px_10px_0px_#0000001A_inset] p-2 rounded-[20px] mb-2">
              <div class="bg-white rounded-[20px] border-x border-y border-[#F47D21] min-h-[56px] px-5 py-2 grid place-content-center text-start">
                <div class="text-[#F47D21] text-[13px] leading-4">سعر المستوى</div>
                <div class="flex items-baseline justify-center gap-1 leading-none">
                  <span class="text-[#F47D21] text-sm">الواحد</span>
                  <span class="text-[#F47D21] font-extrabold text-[26px]" v-text="prices[7]?.perLevelAmount"></span>
                </div>
              </div>
              <div class="price flex items-center gap-x-2">
                <span class="sloped-line">{{ prices[7]?.beforePrice }}</span>
                <p class="bg-gradient-to-l from-[#F47D21] to-[#FF9D52] bg-clip-text !text-transparent !font-bold !text-5xl !mt-0 !mb-0">{{ prices[7]?.originalPrice }}</p>
              </div>
            </div>
            <h6>واستمتع بالاتي:</h6>
            <ul>
              <li>حصص أســـــــاسية:<span> 8 شهرياً</span></li>
              <li>نادى القـــــــــــــــــراءة:<span> مرة أسبوعياً</span></li>
              <li>نادى الســــــــــــــينما:<span>مرة أسبوعياً</span></li>
              <li>نادى المــــــــــــحادثة:<span> يومياً</span></li>
              <li>نادى المـــــــناظرات:<span> مرة شهرياً</span></li>
              <li>نادى لايف كوتش:<span>جلسة مجانية</span></li>
              <li>تقاريــــــر شهريـــــــــــة مفصلة لمستوى اللغة</li>
            </ul>
            <button @click="addToCart(prices[7]?.packageId)">شراء</button>
            <!-- <p class="!text-lg max-sm:!text-md font-normal text-center">الأسعار لا تشمل ضريبة القيمة المضافة VAT</p> -->
          </div>
        </div>
        <div class="package-card">
          <div class="card-header">
            <h3>
              <span> (6 اشهر)</span>
              <br />
              أساسية
            </h3>
          </div>
          <div class="card-body">
            <p>
              باقة مونجلش الأساسية هي الأقل سعراً، ولكنها تحتوي على بعض خصائص دوراتنا التي توفر تجربة تعليمية مميزة
            </p>
            <div class="flex flex-row justify-between items-start bg-[#EAEAEA66] shadow-[0px_4px_10px_0px_#0000001A_inset] p-2 rounded-[20px] mb-2">
              <div class="bg-white rounded-[20px] border-x border-y border-[#F47D21] min-h-[56px] px-5 py-2 grid place-content-center text-start">
                <div class="text-[#F47D21] text-[13px] leading-4">سعر المستوى</div>
                <div class="flex items-baseline justify-center gap-1 leading-none">
                  <span class="text-[#F47D21] text-sm">الواحد</span>
                  <span class="text-[#F47D21] font-extrabold text-[26px]" v-text="prices[45]?.perLevelAmount"></span>
                </div>
              </div>
              <div class="price flex items-center gap-x-2">
                <p class="bg-gradient-to-l from-[#F47D21] to-[#FF9D52] bg-clip-text !text-transparent !font-bold !text-5xl !mt-0 !mb-0">{{ prices[45]?.originalPrice }}</p>
              </div>
            </div>
            <h6>واستمتع بالاتي:</h6>
            <ul>
              <li>حصص أســـــــاسية:<span> 8 شهرياً</span></li>
              <li>نادى القـــــــــــــــــراءة:<span> مرة أسبوعياً</span></li>
              <li>نادى المـــــــناظرات:<span> مرة شهرياً</span></li>
              <li>تقاريــــــر شهريـــــــــــة مفصلة لمستوى اللغة</li>
            </ul>
            <button @click="addToCart(prices[7]?.packageId)">شراء</button>
            <!-- <p class="!text-lg max-sm:!text-md font-normal text-center">الأسعار لا تشمل ضريبة القيمة المضافة VAT</p> -->
          </div>
        </div>
      </div>
      <div class="packages-cards" v-else-if="selectedMenu === 'eight-months'">
        <!-- Eight Months Cards -->
        <div class="package-card">
          <div class="card-header">
            <h3>
              <span> (8 اشهر)</span> <br />
              <span>6مستويات + مستويان مجاناََ</span>
              <br />
              المعايشة بلس
            </h3>
            <p class="badge">
              <span
                >عرض <br />
                <bold>محدود</bold>
              </span>
            </p>
          </div>
          <div class="card-body">
            <p>
              “المعايشة بلس” هي باقتك المثالية، تقدم أقصى قيمة مقابل السعر
              بميزات فريدة وخدمة شاملة تضمن راحتك.
            </p>
            <div class="flex flex-row justify-between items-start bg-[#EAEAEA66] shadow-[0px_4px_10px_0px_#0000001A_inset] p-2 rounded-[20px] mb-2">
              <div class="bg-white rounded-[20px] border-x border-y border-[#F47D21] min-h-[56px] px-5 py-2 grid place-content-center text-start">
                <div class="text-[#F47D21] text-[13px] leading-4">سعر المستوى</div>
                <div class="flex items-baseline justify-center gap-1 leading-none">
                  <span class="text-[#F47D21] text-sm">الواحد</span>
                  <span class="text-[#F47D21] font-extrabold text-[26px]" v-text="prices[58]?.perLevelAmount"></span>
                </div>
              </div>
              <div class="price flex items-center gap-x-2">
                <span class="sloped-line">{{ prices[58]?.beforePrice }}</span>
                <p class="bg-gradient-to-l from-[#F47D21] to-[#FF9D52] bg-clip-text !text-transparent !font-bold !text-5xl !mt-0 !mb-0">{{ prices[58]?.originalPrice }}</p>
              </div>
            </div>
            <h6>واستمتع بالاتي:</h6>
            <ul>
              <li>حصص أســـــــاسية:<span> 8 شهرياً</span></li>
              <li>نادى القـــــــــــــــــراءة:<span> مرة أسبوعياً</span></li>
              <li>نادى الســــــــــــــينما:<span>مرة أسبوعياً</span></li>
              <li>نادى المــــــــــــحادثة:<span> يومياً</span></li>
              <li>نادى المـــــــناظرات:<span> مرة شهرياً</span></li>
              <li>
                نادى الكتــــــــــــــــــــابة:<span>مرة أسبوعياً</span>
              </li>
              <li>نادى الصوتــــــــــيات:<span> بترشيح المعلم</span></li>
              <li>نادى المـــــــــواهب:<span>مرة أسبوعياً</span></li>
              <li>نادى الرســـــــــــــــــــم:<span>مرة أسبوعياً</span></li>
              <li>لقاء تربوي مع ولي الأمر:<span> مرة شهرياً</span></li>
              <li>نادى لايف كوتش:<span>جلسة مجانية</span></li>
              <li>إجتماع شهري لأولياء الأمور</li>
              <li>تقاريــــــر شهريـــــــــــة مفصلة لمستوى اللغة</li>
            </ul>
            <button @click="addToCart(prices[58]?.packageId)">شراء</button>
            <!-- <p class="!text-lg max-sm:!text-md font-normal text-center">الأسعار لا تشمل ضريبة القيمة المضافة VAT</p> -->
          </div>
        </div>
        <div class="package-card">
          <div class="card-header">
            <h3>
              <span> (8 اشهر)</span> <br />
              <span>6مستويات + مستويان مجاناََ</span>
              <br />
              المعايشة
            </h3>
            <p class="badge">
              <span>عرض <br />
                <bold>محدود</bold>
              </span>
            </p>
          </div>
          <div class="card-body">
            <p>
              باقة “المعايشة” توفر العديد من الميزات وهي الخيار المعتاد
              لعملائنا، تضمن الراحة والخدمات المتميزة بكفاءة.
            </p>
            <div class="flex flex-row justify-between items-start bg-[#EAEAEA66] shadow-[0px_4px_10px_0px_#0000001A_inset] p-2 rounded-[20px] mb-2">
              <div class="bg-white rounded-[20px] border-x border-y border-[#F47D21] min-h-[56px] px-5 py-2 grid place-content-center text-start">
                <div class="text-[#F47D21] text-[13px] leading-4">سعر المستوى</div>
                <div class="flex items-baseline justify-center gap-1 leading-none">
                  <span class="text-[#F47D21] text-sm">الواحد</span>
                  <span class="text-[#F47D21] font-extrabold text-[26px]" v-text="prices[59]?.perLevelAmount"></span>
                </div>
              </div>
              <div class="price flex items-center gap-x-2">
                <span class="sloped-line">{{ prices[59]?.beforePrice }}</span>
                <p class="bg-gradient-to-l from-[#F47D21] to-[#FF9D52] bg-clip-text !text-transparent !font-bold !text-5xl !mt-0 !mb-0">{{ prices[59]?.originalPrice }}</p>
              </div>
            </div>
            <h6>واستمتع بالاتي:</h6>
            <ul>
              <li>حصص أســـــــاسية:<span> 8 شهرياً</span></li>
              <li>نادى القـــــــــــــــــراءة:<span> مرة أسبوعياً</span></li>
              <li>نادى الســــــــــــــينما:<span>مرة أسبوعياً</span></li>
              <li>نادى المــــــــــــحادثة:<span> يومياً</span></li>
              <li>نادى المـــــــناظرات:<span> مرة شهرياً</span></li>
              <li>نادى لايف كوتش:<span>جلسة مجانية</span></li>
              <li>تقاريــــــر شهريـــــــــــة مفصلة لمستوى اللغة</li>
            </ul>
            <button @click="addToCart(prices[59]?.packageId)">شراء</button>
            <!-- <p class="!text-lg max-sm:!text-md font-normal text-center">الأسعار لا تشمل ضريبة القيمة المضافة VAT</p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      selectedFilter: "kids",
      selectedMenu: "two-months",
      prices: {},
    };
  },
  methods: {
    toggleFilter(event) {
      this.selectedFilter = event.target.checked ? "kids" : "kids";
      if (this.selectedFilter === "kids") {
        this.selectedMenu = "two-months";
      } else {
        this.selectedMenu = "two-months";
      }
    },
    selectMenu(menu) {
      this.selectedMenu = menu;
    },
    fetchPackagePrices() {
      let url = sessionStorage.getItem("userInfo")
        ? "/api/user/get-course-packages/" + this.selectedFilter
        : "/api/session/get-course-packages/" + this.selectedFilter;
      const userInfo = sessionStorage.getItem("userInfo");
      let headers = {};
      if (userInfo) {
        try {
          const parsedUserInfo = JSON.parse(userInfo);
          const token = parsedUserInfo.token;
          if (token) {
            headers["Authorization"] = `Bearer ${token}`;
          }
        } catch (error) {
          console.error("Error parsing userInfo from sessionStorage:", error);
        }
      }
      axios
        .get(url, { headers })
        .then((response) => {
          const data = response.data;
          console.log("Full API response:", data);
          this.prices = {};

          if (data.success) {
            const packages = data.data;
            packages.forEach((packageData) => {
              console.log("Package Data:", packageData);

              const packageId = packageData.id;
              const packagePrice = packageData.packagePrice;
              const packagePeriod = packageData.packagePeriod;
              let singlePackagePrice = 0;
              const beforePrice = packageData.packageBeforePrice;
              const currency = packageData.currency_en;

              if(packagePeriod == 2) {
                singlePackagePrice = `${currency +''+ Math.floor(packagePrice / 2)}`;
              } else if(packagePeriod == 4) {
                singlePackagePrice = `${currency +''+ Math.floor(packageData.packagePrice / 4)}`;
              } else if(packagePeriod == 6) {
                singlePackagePrice = `${currency +''+ Math.floor(packageData.packagePrice / 6)}`;
              } else if(packagePeriod == 8) {
                singlePackagePrice = `${currency +''+ Math.floor(packageData.packagePrice / 8)}`;
              } else {
                singlePackagePrice = packageData.packagePrice;
              }

              this.prices[packageId] = {
                originalPrice: packagePrice ? `${packagePrice} ${currency}` : null,
                perLevelAmount: singlePackagePrice,
                beforePrice: beforePrice ? `${beforePrice} ${currency}` : null,
                packageId: packageId,
              };
            });
          }
        })
        .catch((error) =>
          console.error("Error fetching package details:", error)
        );
    },
    addToCart(packageId) {
      let url = sessionStorage.getItem("userInfo")
        ? "/api/user/cart"
        : "/api/session/cart";
      const userInfo = sessionStorage.getItem("userInfo");
      let headers = {};
      if (userInfo) {
        try {
          const parsedUserInfo = JSON.parse(userInfo);
          const token = parsedUserInfo.token;

          if (token) {
            headers["Authorization"] = `Bearer ${token}`;
            headers["Content-type"] = "application/json";
          }
        } catch (error) {
          console.error("Error parsing userInfo from sessionStorage:", error);
        }
      }
      axios
        .post(
          url,
          {
            course_package_id: packageId,
            quantity: 1,
          },
          { headers }
        )
        .then((response) => {
          console.log("Item added to cart successfully:", response.data);
          this.$router.push({ name: "CartAr" }).then(() => {
            window.location.reload();
          });
        })
        .catch((error) => {
          console.error(
            "Error adding item to cart:",
            error.response ? error.response.data : error.message
          );
        });
    },
  },
  mounted() {
    this.fetchPackagePrices();
  },
};
</script>

<style scoped>
.packages {
  margin-top: -85px;
}

.packages-filter-switch {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  position: relative;
  direction: rtl;
}

.label-out {
  position: absolute;
  width: 250px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;
  font-size: 20px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 120px;
  height: 45px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  border-radius: 34px;
  cursor: pointer;
  transition: background-color 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 35px;
  width: 35px;
  left: 5px;
  bottom: 5px;
  background-color: orange;
  border-radius: 50%;
  transition: transform 0.4s;
}

input:checked + .slider:before {
  transform: translateX(75px);
}

input:checked ~ .slider .label-left {
  opacity: 1;
}

input:checked ~ .slider .label-right {
  opacity: 0;
}

input:not(:checked) ~ .slider .label-left {
  opacity: 0;
}

input:not(:checked) ~ .slider .label-right {
  opacity: 1;
}

.label {
  position: absolute;
  font-size: 20px;
  font-weight: bold;
  color: orange;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.label-left {
  left: 15px;
}

.label-right {
  right: 15px;
}

.packages {
  background-image: url("https://monglish.b-cdn.net/home/bg.jpg");
  background-size: cover;
  background-position: center;
  font-family: "DIN Next LT Arabic", sans-serif;
  padding: 50px 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
}

.packages-title-n {
  text-align: center;
  color: #fff;
  margin-bottom: 40px;
  padding-top: 50px;
}

.packages-title-n h3 {
  color: #fff;
  font-size: 2.5rem;
  font-weight: 500;
  line-height: 100%;
}

.packages-title-n h2 {
  font-size: 3rem;
  font-weight: 500;
}

.packages-menu-n {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  font-size: 1.5rem;
  direction: rtl;
}

.packages-menu-n ul {
  list-style: none;
  padding: 10px;
  display: flex;
  border-bottom: 1px solid black;
}

.packages-menu-n li {
  margin: 0 20px;
  color: white;
  cursor: pointer;
  position: relative;
}

.packages-menu-n li:hover,
.packages-menu li:focus,
.packages-menu li:active,
.packages-menu li.selected {
  color: #ffa500;
}

.packages-menu-n li.selected::after {
  content: "";
  display: inline-block;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M9.2793 2.82026L4.10131 7.99818L9.2793 13.1761L7.22864 15.2268L-8.29697e-05 7.99818L7.22864 0.769531L9.2793 2.82026Z" fill="white"/><path d="M13.9493 15.2268L6.72069 7.99818L13.9493 0.769531L16 2.82026L10.8221 7.99818L16 13.1761L13.9493 15.2268Z" fill="white"/></svg>');
  width: 16px;
  height: 16px;
  position: absolute;
  right: -25px;
  top: 50%;
  transform: translateY(-50%);
}

.packages-menu-n li.selected::before {
  content: "";
  display: block;
  width: 100%;
  height: 2px;
  background-color: #ffa500;
  position: absolute;
  bottom: -10px;
  left: 0;
}

.packages-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  align-items: center;
  direction: rtl;
}

.package-card {
  background: #fff;
  border-radius: 30px;
  padding: 20px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.card-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.card-header h3 {
  color: #000000;
  font-size: 27px;
  margin-top: 50px;
  margin-bottom: -25px;
}

.card-header h3 span {
  color: #175f87;
  font-size: 24px;
}

.card-header .badge {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-right: 160px solid transparent;
  border-top: 160px solid #ff8901;
  margin-top: -0.5px;
  border-radius: 20px 0 0 0;
}

.card-header .badge span {
  position: absolute;
  left: 15px;
  top: -150px;
  text-align: center;
  transform: rotate(-45deg);
  white-space: nowrap;
  font-size: 20px;
  color: #fff;
}

.card-header .badge bold {
  font-size: 32px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.card-body p {
  color: #666;
  margin-bottom: 20px;
  margin-top: 20px;
  font-size: 13px;
}

.card-body h2 {
  color: #f47d21;
  font-weight: 600;
  font-size: 34px;
  margin-bottom: 25px;
  margin-top: -15px;
}

.card-body h6 {
  font-weight: 900;
  color: #000000;
  font-size: 14px;
  margin-top: -5px;
  margin-bottom: 5px;
}

.card-body ul {
  list-style: none;
  padding: 0;
}

.card-body li {
  position: relative;
  padding-right: 20px;
  margin-bottom: 10px;
  color: #666;
  border-bottom: 1px solid #e9e9e9;
  padding-bottom: 5px;
}

.card-body li span {
  color: #f47e23;
  float: left;
}

.card-body li::before {
  content: "✓";
  position: absolute;
  right: 0;
  color: #f48026;
  font-weight: bold;
}

.card-body li:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.card-body button {
  width: 100%;
  padding: 10px;
  background: linear-gradient(45deg, #fe9b4f, #f47e23);
  color: white;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  margin-bottom: 10px;
  font-size: larger;
}

@media (max-width: 800px) {
  .packages-title-n h3 {
    font-size: 1.5rem;
  }

  .packages-title-n h2 {
    font-size: 2rem;
  }
}

.sloped-line {
  position: relative;
  display: inline-block;
  color: #808080;
  font-size: 25px;
  opacity: 0.7;
}

.sloped-line::after {
  content: "";
  position: absolute;
  top: 80%;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #fc3b3b;
  transform: rotate(-15deg);
  transform-origin: left center;
}
</style>